module.exports = __webpack_public_path__ + "img/water.d9d55615.png";